/**
 * Shop the look
 * - Carrusel por CSS (scroll-snap); este JS maneja el modal, los selectores de
 *   variante, el add-to-cart (sin cerrar el modal, con mensaje de éxito en el botón)
 *   y la actualización del contador del minicart al cerrar.
 */
(function () {
  if (window.__shopTheLookInit) return;
  window.__shopTheLookInit = true;

  var cartChanged = false;

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    } catch (e) {}
    return '$' + Math.round(cents / 100);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('stl-lock');
    // Asegurar que cada producto tenga su variante calculada
    modal.querySelectorAll('[data-stl-product]').forEach(updateVariant);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-stl-modal].is-open')) {
      document.body.classList.remove('stl-lock');
    }
    if (cartChanged) {
      cartChanged = false;
      fetch(root() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (typeof window.cartCount === 'function') window.cartCount(cart);
          if (typeof window.initFreeshippingGoal === 'function') window.initFreeshippingGoal(cart);
        })
        .catch(function () {});
    }
  }

  function getVariants(product) {
    var el = product.querySelector('[data-stl-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function updateVariant(product) {
    var variants = getVariants(product);
    var selects = product.querySelectorAll('select[data-stl-option]');
    var btn = product.querySelector('[data-stl-add]');
    if (!btn) return;

    var variant;
    if (selects.length) {
      var chosen = [].map.call(selects, function (s) { return s.value; });
      variant = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
    } else {
      variant = variants[0];
    }

    var txt = btn.querySelector('[data-stl-add-text]');
    btn.classList.remove('is-success');

    if (!variant) {
      btn.disabled = true;
      btn.removeAttribute('data-variant-id');
      if (txt) txt.textContent = 'NO DISPONIBLE';
      return;
    }

    btn.setAttribute('data-variant-id', variant.id);
    btn.disabled = !variant.available;
    if (txt) txt.textContent = variant.available ? 'AGREGAR' : 'AGOTADO';

    var priceEl = product.querySelector('[data-stl-price]');
    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="stl-product__compare">' + money(variant.compare_at_price) + '</s> ';
      }
      html += money(variant.price);
      priceEl.innerHTML = html;
    }
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;

    var txt = btn.querySelector('[data-stl-add-text]');
    var original = (txt && txt.getAttribute('data-default')) || (txt ? txt.textContent : 'AGREGAR');
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: 1,
        sections: 'cart-notification-content,cart-notification-crosssell-products',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (!res.ok) {
          btn.classList.add('is-error');
          if (txt) txt.textContent = 'NO DISPONIBLE';
          setTimeout(function () {
            btn.classList.remove('is-error');
            if (txt) txt.textContent = original;
          }, 1800);
          return;
        }
        cartChanged = true;
        // Repintar el minicart (sin abrirlo) para que los productos salgan ya cargados
        try {
          var cn = document.querySelector('cart-notification');
          if (cn && res.data && res.data.sections && typeof cn.updateContent === 'function') {
            cn.updateContent(res.data.sections);
          }
        } catch (e) {}
        // Actualizar el numerito del icono y la barra de envío gratis de inmediato
        fetch(root() + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (typeof window.cartCount === 'function') window.cartCount(cart);
            if (typeof window.initFreeshippingGoal === 'function') window.initFreeshippingGoal(cart);
          })
          .catch(function () {});
        btn.classList.add('is-success');
        if (txt) txt.textContent = '✓ AGREGADO';
        setTimeout(function () {
          btn.classList.remove('is-success');
          if (txt) txt.textContent = original;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-stl-open]');
    if (open) { e.preventDefault(); openModal(open.getAttribute('data-stl-target')); return; }

    var close = e.target.closest('[data-stl-close]');
    if (close) { e.preventDefault(); var m = close.closest('[data-stl-modal]'); if (m) closeModal(m); return; }

    var add = e.target.closest('[data-stl-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-stl-option]');
    if (sel) { var p = sel.closest('[data-stl-product]'); if (p) updateVariant(p); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-stl-modal].is-open');
      if (open) closeModal(open);
    }
  });

  /* ---------- Carrusel: flechas (hover desktop, solo si hay overflow) ---------- */
  function initCarousel(wrap) {
    if (!wrap || wrap.__stlInit) return;
    wrap.__stlInit = true;
    var scroller = wrap.querySelector('.stl-carousel');
    if (!scroller) return;
    var prev = wrap.querySelector('[data-stl-prev]');
    var next = wrap.querySelector('[data-stl-next]');

    function step() {
      var slide = scroller.querySelector('.stl-slide');
      var w = slide ? slide.getBoundingClientRect().width : scroller.clientWidth * 0.8;
      var cs = getComputedStyle(scroller);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return w + gap;
    }

    function update() {
      var overflow = scroller.scrollWidth - scroller.clientWidth > 1;
      wrap.classList.toggle('stl-has-overflow', overflow);
      wrap.classList.toggle('stl-at-start', scroller.scrollLeft <= 1);
      wrap.classList.toggle('stl-at-end', scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 1);
      var media = scroller.querySelector('.stl-slide__media');
      if (media) wrap.style.setProperty('--stl-arrow-top', media.offsetHeight / 2 + 'px');
    }

    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Recalcular cuando carguen imágenes (cambia la altura de la media)
    scroller.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });
    update();
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('.stl-carousel-wrap').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') initCarousels();
  else document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  // Editor de temas
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
